/**************************************************
 * Nombre:       Tarjeta_Piso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import Tarjeta_Piso_Vista from "./Tarjeta_Piso_Vista";


const Tarjeta_Torre_Vista = ({item, click, reservasDia, fechaDia}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{border: 1, borderColor: theme.palette.primary.main + 50, borderRadius: 4}}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-start'}
                  sx={{
                      backgroundColor: theme.palette.primary.main,
                      borderTopRightRadius: 10,
                      borderTopLeftRadius: 10,
                      py: 1,
                      px: 2
                  }}
            >
                <Typography sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    lineHeight: 1.1,
                    color: '#fff'
                }}>{item.torre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 3}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                >


                    {item.habsPisos.map((item, index) => {

                        if (!item.habitaciones.length) {
                            return ''
                        } else {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Tarjeta_Piso_Vista piso={item} reservasDia={reservasDia} fechaDia={fechaDia}
                                                        click={click}/>
                                </Grid>
                            )
                        }


                    })}

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Torre_Vista